// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Orders_invalidDataError__lEf68"};